import { HttpClient } from '@adapters/HttpClient';

export interface UpdateCRMSettingsRequest {
    setting_key: 'crm.managed_by' | 'crm.enabled';
    value: 'tenant_external' | 'tenant_3pl' | boolean;
    team_id: number;
}

export class CRMSettingsApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async updateCRMSettings(data: UpdateCRMSettingsRequest): Promise<void> {
        await this.httpClient.put('/team/settings', {
            setting_key: data.setting_key,
            value: data.value,
            team_id: data.team_id,
        });
    }
}

